import RequireGlobalPermissionPage from 'components/permissions/RequireGlobalPermissionPage';
import HierarchyTable from 'components/tables/data/hierarchy/HierarchyTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';

/** Global hierarchy list page. */
export default function HierarchiesPage() {
  return (
    <RequireGlobalPermissionPage permission="manage-hierarchies">
      <DashboardLayout height="screen" breadcrumbs={[{ title: 'Hierarchie' }]}>
        <HierarchyTable />
      </DashboardLayout>
    </RequireGlobalPermissionPage>
  );
}
